import { Badge } from "@/components/ui/badge";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useTranslation } from "@/features/utils/i18n";
import { LinkSimpleIcon } from "@phosphor-icons/react";

interface ExternalBadgeProps {
  adapter: {
    adapter: string;
    id: string;
  };
  className?: string;
}

export function ExternalBadge({ adapter, className }: ExternalBadgeProps) {
  const { t } = useTranslation("common");

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge variant="outline" className={className}>
            <LinkSimpleIcon className="h-3 w-3 mr-1" weight="bold" />
            {t("external.badge")}
          </Badge>
        </TooltipTrigger>
        <TooltipContent>
          <p>{t("external.tooltip", { adapter: adapter.adapter })}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
